import { render, staticRenderFns } from "./GTrendAnalysisPsychologicalSafetyChart.vue?vue&type=template&id=58dc84fc&scoped=true&"
import script from "./GTrendAnalysisPsychologicalSafetyChart.vue?vue&type=script&lang=ts&"
export * from "./GTrendAnalysisPsychologicalSafetyChart.vue?vue&type=script&lang=ts&"
import style0 from "./GTrendAnalysisPsychologicalSafetyChart.vue?vue&type=style&index=0&id=58dc84fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dc84fc",
  null
  
)

export default component.exports